<template>
  <div class="my-cer-container">
      <div class="mycer-content" :style="'background: url('+row.image6+')'">
        <div class="widget" :style="'background:'+row.bgColor6"> 
            <div class="bg-title" v-html="row.title6"></div>
            <div class="text" v-html="row.body6"></div>
            <router-link v-if="row.button6" :to="row.redirect6" class="cer-btn">
                <div class="d-flex align-items-center">
                    <span v-html="row.button6"></span>
                    <span class="icon-back"></span>
                </div>
            </router-link>
        </div>
      </div>
  </div>
</template>

<style scoped>
.my-cer-container {
  margin-bottom: 0.7rem;
}
.mycer-content {
  padding: 50px 0;
  background-size: cover !important;
  height: 560px;
  position: relative;
}
.widget {
    position: absolute;
    left: 51%;
    bottom: 100px;
    background: #fff;
    padding: 50px
}
.bg-title {
  font-size: 50px;
  margin-bottom: 15px;
  color: #0020A5;
}
.text {
    color: #0020A5;
    margin-bottom: 15px;
    font-size: 26px;
    /* font-weight: 600; */
}
.cer-btn {
    display: inline-block;
    color: #fff;
    font-size: 18px;
    padding: 8px 20px;
    line-height: 1;
    border: 1px solid #0020A5;
    color: #0020A5;
}
.cer-btn:hover {
    background: #0020A5;
    color: #fff;
}
.cer-btn:active {
    opacity: 0.7;
}
.cer-btn:hover .icon-back:before {
    color: #fff;
}
.icon-back:before {
    color: #0020A5;
    font-weight: bold;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .mycer-content {
    padding: 80px 0;
    height: auto;
  }
  .widget {
    width: calc(100% - 40px);
    left: 20px;
    position: relative;
    top: 0;
    padding: 47px 43px
  }
  .bg-title {
    font-size: 38px;
  }
  .text {
    margin-bottom: 19px;
    font-size: 22px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .widget {
    width: auto;
    display: inline-block;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .widget {
    position: absolute;
    left: 50px;
    bottom: 80px;
    background: #fff;
    padding: 50px;
    transform: none;
  }
  .text {
    font-size: 19px;
    margin-bottom: 18px;
  }
  .bg-title {
    font-size: 43px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .widget {
    right: 100px;
    left: auto;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section4",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
